// React
import React from "react";
import CalendarEdit from "./CalendarEdit";

const CalendarEditBirthdays = props => (
    <CalendarEdit {...props} calendarType="birthdays" />
);
export default CalendarEditBirthdays;